import { render, staticRenderFns } from "./JobActionsMenu.vue?vue&type=template&id=2c27e4f4"
import script from "./JobActionsMenu.vue?vue&type=script&lang=js"
export * from "./JobActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./JobActionsMenu.vue?vue&type=style&index=0&id=2c27e4f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports